import React, { useEffect } from 'react'
import {
  Card,
  CardContent,
  CardMedia,
  Button,
  CardActions,
} from '@material-ui/core'
import { useStyles } from './classes'


const ResultCard = ({ card, handleClickOpen }) => {
  const classes = useStyles()


  useEffect(() => { }, [card])

  const onOpen = () => {
    handleClickOpen(card.restaurantId)
  }

  return (
    <Card className={classes.root} style={{ borderRadius: '25px' }}>
      <CardMedia
        className={classes.media}
        image={card.dishImage}
        title='Dish Image'
      ><div className={classes.overlay}></div></CardMedia>
      <CardContent
        style={{
          textAlign: 'center',
          fontFamily: 'Gilroy-ExtraBold, serif',
          color: '#000',
        }}
      >
        {card.restaurantName}
        <CardActions>
          <Button
            className={classes.linkButton}
            disableRipple
            onClick={() => onOpen()}
          >
            View More
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  )
}

export default ResultCard
